export default __webpack_public_path__ + "static/media/odp.fbfbc57a.svg";